// extracted by mini-css-extract-plugin
module.exports = {"data-table-actions":"_1uBYk-","dataTableActions":"_1uBYk-"};